<div class="toast-container" aria-live="polite" aria-atomic="false">
  @for (toast of toastService.toasts(); track toast.id) {
    <div class="toast" [class.toast--success]="toast.type === 'success'" [class.toast--error]="toast.type === 'error'">
      <i class="toast__icon ph"
         [class.ph-check-circle]="toast.type === 'success'"
         [class.ph-warning-circle]="toast.type === 'error'">
      </i>
      <span class="toast__message">{{ toast.message }}</span>
      <button class="toast__close" (click)="toastService.dismiss(toast.id)" aria-label="Cerrar">
        <i class="ph ph-x"></i>
      </button>
    </div>
  }
</div>
